export default {
	id: "vrchat-world-tutorial",
	pride: 8192,
	slug: "vrchat-world-tutorial",
	category: "tool",
	status: "released",
	experienceable: true,
	titleKey: {
		zh: "VRChat 世界制作初级教程"
	},
	descriptionKey: {
		zh: "VRChat 世界制作的入门教程网站。"
	},
	date: { year: 2026, month: 6 },
	genres: ["教程", "VRChat"],
	themes: ["世界制作"],
	engine: "Web",
	platform: ["Web"],
	tags: ["VRChat", "教程"],
	links: [
		{ type: "web", url: "https://vrchat-world-tutorial.pages.dev/", textKey: { zh: "阅读教程" } }
	]
};
